import React, { useState } from 'react';
import cls from 'classnames';
import { IconComp } from '../IconComponent';
import { selectRecipient } from '../../../ducks/app/selectors';
import { useSelector } from 'react-redux';

export type SKInputProps = React.HTMLProps<HTMLInputElement> & {
  icon?: React.ReactType;
  disabled?: boolean;
  error?: boolean;
};

export const SKInput: React.FC<SKInputProps> = ({ disabled, error, icon, ...props }: SKInputProps) => {
  const [focus, setFocus] = useState<boolean>(false);
  const recipientInputValue = useSelector(selectRecipient);

  return (
    <div
      className={cls('sk-input-container flex items-center bg-white p-2 rounded-xl border border-cloud-400', {
        'border-kiwi-400': focus,
        'border-cloud-300 cursor-not-allowed bg-cloud-50': disabled,
        'border-strawberry-400': error,
      })}
    >
      {icon && <IconComp size={20} icon={icon} className="stroke-current text-cloud-400" />}
      <input
        {...props}
        value={recipientInputValue}
        disabled={disabled}
        className={cls('ml-1.5 text-lg w-full', {
          'cursor-not-allowed bg-cloud-50': disabled,
        })}
        onFocus={(): void => {
          !disabled && setFocus(true);
        }}
        onBlur={(e): void => {
          setFocus(false);
          props.onBlur && props.onBlur(e);
        }}
      />
    </div>
  );
};
